import { useCallback, useEffect, useRef, useState } from "react";

const SEARCH_DEBOUNCE_MS = 500;

export function useDebouncedSearch(initialValue = "") {
  const [searchTerm, setSearchTerm] = useState(initialValue);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(initialValue);
  const searchInputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, SEARCH_DEBOUNCE_MS);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const captureSearchFocus = useCallback(
    () => searchInputRef.current === document.activeElement,
    [],
  );

  const restoreSearchFocus = useCallback((wasFocused) => {
    if (wasFocused && searchInputRef.current) {
      searchInputRef.current.focus({ preventScroll: true });
    }
  }, []);

  return {
    searchTerm,
    setSearchTerm,
    debouncedSearchTerm,
    searchInputRef,
    captureSearchFocus,
    restoreSearchFocus,
  };
}
